import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueTailwind from 'vue-tailwind';
import mainTheme from './tailwindTheme';
import lodash from 'lodash';
import VueTelInput from 'vue-tel-input';
import Toasted from 'vue-toasted';
import dayjs from 'dayjs';
import VJsoneditor from 'v-jsoneditor';
import VueGoodTablePlugin from 'vue-good-table';
import { sendMpEvent, timeMpEvent } from './utils/mixpanel-analytics/util.mp';
import { MP_VALUE } from './utils/mixpanel-analytics/enum.mp-value';
import VueMeta from 'vue-meta';
import VueSocialSharing from 'vue-social-sharing';
import VueClipboard from 'vue-clipboard2';

Vue.config.productionTip = false;
Vue.prototype.$lodash = lodash;
Vue.prototype.$dayjs = dayjs;

Vue.use(VueTailwind, mainTheme);
Vue.use(VueTelInput);
Vue.use(Toasted);
Vue.use(VJsoneditor);
Vue.use(VueGoodTablePlugin);
Vue.use(VueSocialSharing);
Vue.use(VueClipboard);

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});

Vue.toasted.register(
  'mainToast',
  payload => {
    return payload.message;
  },
  {
    className: 'main--toast',
    position: 'top-center',
    duration: 4000,
  },
);

Vue.use({
  install() {
    Vue['sendMpEvent'] = sendMpEvent;
    Vue.prototype.$sendMpEvent = sendMpEvent;
    Vue['mp_value'] = MP_VALUE;
    Vue.prototype.$mp_value = MP_VALUE;
    Vue['timeMpEvent'] = timeMpEvent;
    Vue.prototype.$timeMpEvent = timeMpEvent;
  },
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
